import React, { useCallback, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { DownloadOutlined as SystemUpdateAltIcon } from '@ant-design/icons';
import { Button, Spin } from 'antd';

import Alert from 'components/Alert';
import { saveAs } from 'file-saver';
import { formatDate } from 'helpers/date';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

export const ExportAffiliateComissions = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const [totalItems] = useObservable(() => affiliateCommissionsService.getTotalItems(), []);

  const [exportReport] = useCallbackObservable(() => {
    setLoading(true);
    return affiliateCommissionsService.export().pipe(
      tap(data => {
        const dateExport = formatDate(new Date(), 'dd-MM-yyyy');
        const fileExport = new Blob([data as any], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `comissoes-pagas-afiliados-${dateExport}.csv`);
        setLoading(false);
      }),
      catchError(() => {
        setLoading(false);
        return of(true);
      })
    );
  }, []);

  const handleExport = useCallback(async () => {
    if (totalItems > 3000) {
      await Alert.show({
        title: 'Atenção',
        message: 'É possível exportar no máximo 3 mil registros por relatório. Refaça o filtro para poder exportar.'
      });
      return;
    }

    exportReport();
  }, [exportReport, totalItems]);

  return (
    <Button
      className='text-sm normal-case'
      disabled={!totalItems || loading}
      onClick={handleExport}
      type='text'
      icon={loading ? <Spin size='small' /> : <SystemUpdateAltIcon />}
    >
      Exportar
    </Button>
  );
};
